import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LandingComponent } from './pages/landing/landing.component';
import { CreatorComponent } from './pages/creator/creator.component';


export const AppRoutes: Routes = [
  {
    path: '',
    component: LandingComponent
  },
  {
    path: 'creator',
    component: CreatorComponent
  }, 
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
  }]},
  {
    path: '**',
    redirectTo: 'dashboard'
  }
]
